import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";
import Select from 'react-select';
import Switch from "react-switch";
import { toast } from 'react-toastify';

import { consultaEstados, consultaCiudMunic, consultaParroquia } from '../../funciones/PefilFunction';

let idPais = 1;

class BecaSocioEc extends Component {
    state = {
        estados:[],
        municipios: [],
        parroquias: [],
        loadEstados: true,
        loadMunicipio: false,
        loadParroquia: false,

        nombre1: this.props.datos.nombre1.text,
        nombre2: this.props.datos.nombre2.text,
        cedula: this.props.datos.cedula.text,
        apellido1: this.props.datos.apellido1.text,
        apellido2: this.props.datos.apellido2.text,
        parentesco: this.props.datos.parentesco.text,
        estadoSelect: this.props.datos.estadoSelect,
        municipioSelect: this.props.datos.municipioSelect,
        parroquiaSelect: this.props.datos.parroquiaSelect,
        ciudad: this.props.datos.ciudad.text,
        sector: this.props.datos.sector.text,
        casa: this.props.datos.casa.text,
        calle: this.props.datos.calle.text,
        chkPr: this.props.datos.chkPr.value,
        chkAl: this.props.datos.chkAl.value,
        tlf1: this.props.datos.tlf1.text,
        tlf2: this.props.datos.tlf2.text,
        email: this.props.datos.email.text,
        tlf3: this.props.datos.tlf3.text,
        instruccion: this.props.datos.instruccion.text,
        ocupacion: this.props.datos.ocupacion.text,
        trabajo: this.props.datos.trabajo.text,
        direccionT: this.props.datos.direccionT.text,
        cargo: this.props.datos.cargo.text,
    }

    componentDidMount = () => {
        consultaEstados (idPais, (resp) => {
            this.setState({
                estados: resp,
                loadEstados: false
            })
        })
    }

    cambiaValor = (prop, err) => (e) => {
        let campo ={
            text: e.target.value,
            errMess: err
        }
        this.props.funcion(prop, campo, "datosBecaSocioEc")
    }

    cambiaValorEmail = (prop, err) => (e) => {
        let expReg = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i;

        let campo = {
            text: e.target.value,
            errMess: err
        }

        if (expReg.test(e.target.value) === false && e.target.value !== "") {
            toast.error("El formato del Email es incorrecto",{autoClose: 4000});
            campo = { text: "", errMess: err }
            
            this.setState ({[prop]: "" })
        }

        this.props.funcion(prop, campo, "datosBecaSocioEc")
    }

    cambiaState = (prop) => (e) => {
        this.setState({
            [prop]: (e.target.value).toUpperCase()
        })
    }

    valorSelectEstado = (estadoSelect) => {
        let campo = {value: estadoSelect.value, label: estadoSelect.label, errMess: "Selecciona el Estado de la Dirección de Habitación" }
        let campoMuni = { value: "", label: '- Selecciona un Municipio -', errMess: "Selecciona el Municipio de la Dirección de Habitación" }
        let campoParr = { value: "", label: '- Selecciona una Parroquia -', errMess: "Selecciona la Parroquia de la Dirección de Habitación" }
        
        this.props.funcion("estadoSelect", campo, "datosBecaSocioEc")
        this.props.funcion("municipioSelect", campoMuni, "datosBecaSocioEc")
        this.props.funcion("parroquiaSelect", campoParr, "datosBecaSocioEc")

        this.setState({
            estadoSelect,
            loadMunicipio: true,
            municipioSelect: campoMuni,
            parroquiaSelect: campoParr,
        }, () => {
            consultaCiudMunic (estadoSelect.value, () => {}, (resp) => {
                this.setState({
                    municipios: resp,
                    loadMunicipio: false
                })
            })
        })
    }

    valorSelectMunicipio = (municipioSelect) => {
        let campo = {value: municipioSelect.value, label: municipioSelect.label, errMess: "Selecciona el Municipio de la Dirección de Habitación" }
        let campoParr = { value: "", label: '- Selecciona una Parroquia -', errMess: "Selecciona la Parroquia de la Dirección de Habitación" }

        this.props.funcion("municipioSelect", campo, "datosBecaSocioEc")
        this.props.funcion("parroquiaSelect", campoParr, "datosBecaSocioEc")

        this.setState({
            municipioSelect,
            loadParroquia: true,
            parroquiaSelect: campoParr,
        }, () => {
            consultaParroquia (municipioSelect.value, (resp) => {
                this.setState({
                    parroquias: resp,
                    loadParroquia: false
                })
            })
        })
    }

    valorSelectParroquia = (parroquiaSelect) => {
        let campo = { value: parroquiaSelect.value, label: parroquiaSelect.label, errMess: "Selecciona la Parroquia de la Dirección de Habitación" }
        this.props.funcion("parroquiaSelect", campo, "datosBecaSocioEc")
        this.setState({ parroquiaSelect })
    }

    cambiaSwitch = () => {
        let campochkPr = { value: !this.state.chkPr, errMess: "" }
        let campochkAl = { value: !this.state.chkAl, errMess: "" }

        this.setState({
            chkPr: !this.state.chkPr,
            chkAl: !this.state.chkAl
        }, () => {
            this.props.funcion("chkPr", campochkPr, "datosBecaSocioEc")
            this.props.funcion("chkAl", campochkAl, "datosBecaSocioEc")
        })
    }

    render() {
        let  { estadoSelect, estados, municipioSelect, municipios, parroquiaSelect, parroquias, chkPr, chkAl,
            loadEstados, loadMunicipio, loadParroquia,
            nombre1, nombre2, cedula, apellido1, apellido2, parentesco, ciudad, sector, casa, calle, tlf1, tlf2,
            email, tlf3, instruccion, ocupacion, trabajo, direccionT, cargo } = this.state;

        return (
            <React.Fragment>
                <div className="custom-alert-info custom-mt-10">Información Socio - Económica</div>
                <div style={{paddingRight: 10, paddingLeft: 20}}>
                    <div className="custom-alert-warning custom-mt-10">Datos del Representante y/o Representante Económico</div>
                    <Row>
                        <Col md={5} className="custom-mt-10">
                            <div className="text-muted">Primer Nombre *</div>
                            <input type="text" value={nombre1} onChange={this.cambiaState("nombre1")} onBlur={this.cambiaValor("nombre1", "El campo Primer Nombre del representante es obligatorio")} className="form-control" placeholder="Primer Nombre"/>
                        </Col>
                        <Col md={5} className="custom-mt-10">
                            <div className="text-muted">Segundo Nombre</div>
                            <input type="text" value={nombre2} onChange={this.cambiaState("nombre2")} onBlur={this.cambiaValor("nombre2", "")} className="form-control" placeholder="Segundo Nombre"/>
                        </Col>
                        <Col md={2} className="custom-mt-10">
                            <div className="text-muted">Cédula *</div>
                            <input type="text" value={cedula} onChange={this.cambiaState("cedula")} onBlur={this.cambiaValor("cedula", "El campo Cédula del representante es obligatorio")} className="form-control" placeholder="Cédula"/>
                        </Col>
                        <Col md={5} className="custom-mt-10">
                            <div className="text-muted">Primer Apellido *</div>
                            <input type="text" value={apellido1} onChange={this.cambiaState("apellido1")} onBlur={this.cambiaValor("apellido1", "El campo Primer Apellido del representante es obligatorio")} className="form-control" placeholder="Primer Apellido"/>
                        </Col>
                        <Col md={5} className="custom-mt-10">
                            <div className="text-muted">Segundo Apellido</div>
                            <input type="text" value={apellido2} onChange={this.cambiaState("apellido2")} onBlur={this.cambiaValor("apellido2", "")} className="form-control" placeholder="Segundo Apellido"/>
                        </Col>
                        <Col md={2} className="custom-mt-10">
                            <div className="text-muted">Parentesco</div>
                            <input type="text" value={parentesco} onChange={this.cambiaState("parentesco")} onBlur={this.cambiaValor("parentesco", "El campo Parentesco del Representante es obligatorio")} className="form-control" placeholder="Ej.: Padre"/>
                        </Col>
                    </Row>

                    <div className="custom-alert-warning custom-mt-10">Dirección de Habitación (Representante y/o Responsable Económico)</div>
                    <Row>
                        <Col md={4} className="custom-mt-10">
                            <div className="text-muted">Estado *</div>
                            <Select
                                isSearchable ={true}
                                value={estadoSelect}
                                onChange={this.valorSelectEstado}
                                options={estados}
                                isLoading={loadEstados}
                            />
                        </Col>
                        <Col md={4} className="custom-mt-10">
                            <div className="text-muted">Municipio *</div>
                            <Select
                                isSearchable ={true}
                                value={municipioSelect}
                                onChange={this.valorSelectMunicipio}
                                options={municipios}
                                isLoading={loadMunicipio}
                            />
                        </Col>
                        <Col md={4} className="custom-mt-10">
                            <div className="text-muted">Parroquia *</div>
                            <Select
                                isSearchable ={true}
                                value={parroquiaSelect}
                                onChange={this.valorSelectParroquia}
                                options={parroquias}
                                isLoading={loadParroquia}
                            />
                        </Col>
                        <Col md={4} className="custom-mt-10">
                            <div className="text-muted" style={{fontSize: 11}}>Ciudad</div>
                            <input type="text" value={ciudad} onChange={this.cambiaState("ciudad")} onBlur={this.cambiaValor("ciudad", "")} className="form-control" placeholder="Ej.: Caracas"/>
                        </Col>
                        <Col md={4} className="custom-mt-10">
                            <div className="text-muted" style={{fontSize: 11}}>Urbanización, Sector, Vereda *</div>
                            <input type="text" value={sector} onChange={this.cambiaState("sector")} onBlur={this.cambiaValor("sector", "El campo Urbanización de Dirección de Habitación es Obligatorio")} className="form-control" placeholder="Sector"/>
                        </Col>
                        <Col md={4} className="custom-mt-10">
                            <div className="text-muted" style={{fontSize: 11}}>Edificio, Apartamento, Casa, Quinta *</div>
                            <input type="text" value={casa} onChange={this.cambiaState("casa")} onBlur={this.cambiaValor("casa", "El campo Edificio de Dirección de Habitación es Obligatorio")} className="form-control" placeholder="Número"/>
                        </Col>
                        <Col md={8} className="custom-mt-10">
                            <div className="text-muted">Avenida, Calle, Esquina *</div>
                            <input type="text" value={calle} onChange={this.cambiaState("calle")} onBlur={this.cambiaValor("calle", "El campo Avenida de Dirección de Habitación es Obligatorio")} className="form-control" placeholder="Avenida"/>
                        </Col>
                        <Col md={4} className="custom-mt-10">
                            <div className="text-muted">Tenencia de la Vivienda *</div>
                            <Row>
                                <Col md={6} align="center" style={{paddingTop: 10, fontSize: 11}}>
                                    <Switch height={12} width={24} onChange={this.cambiaSwitch} checked={chkPr} /> Propia
                                </Col>
                                <Col md={6} align="center" style={{paddingTop: 10, fontSize: 11}}>
                                    <Switch height={12} width={24} onChange={this.cambiaSwitch} checked={chkAl} /> Alquilada
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6} className="custom-mt-10">
                            <div className="text-muted">Telf. Habitación</div>
                            <input type="text" value={tlf1} onChange={this.cambiaState("tlf1")} onBlur={this.cambiaValor("tlf1", "")} className="form-control" placeholder="Ej.: 02121234567"/>
                        </Col>
                        <Col md={6} className="custom-mt-10">
                            <div className="text-muted">Telf. Celular</div>
                            <input type="text" value={tlf2} onChange={this.cambiaState("tlf2")} onBlur={this.cambiaValor("tlf2", "")} className="form-control" placeholder="Ej.: 04121234567"/>
                        </Col>
                        <Col md={8} className="custom-mt-10">
                            <div className="text-muted">Email *</div>
                            <input type="text" value={email} onChange={this.cambiaState("email")} onBlur={this.cambiaValorEmail("email", "El campo Email es obligatorio")} className="form-control" placeholder="Ej.: ejemplo@ejemplo.com"/>
                        </Col>
                        <Col md={4} className="custom-mt-10">
                            <div className="text-muted">Teléfono de Oficina</div>
                            <input type="text" value={tlf3} onChange={this.cambiaState("tlf3")} onBlur={this.cambiaValor("tlf3", "")} className="form-control" placeholder="Ej.: 02121234567"/>
                        </Col>
                        <Col md={4} className="custom-mt-10">
                            <div className="text-muted">Grado de Instruccion *</div>
                            <input type="text" value={instruccion} onChange={this.cambiaState("instruccion")} onBlur={this.cambiaValor("instruccion", "El campo Grado de Instrucción es obligatorio")} className="form-control" placeholder="Instrucción"/>
                        </Col>
                        <Col md={4} className="custom-mt-10">
                            <div className="text-muted">Ocupación *</div>
                            <input type="text" value={ocupacion} onChange={this.cambiaState("ocupacion")} onBlur={this.cambiaValor("ocupacion", "El campo Ocupación es obligatorio")} className="form-control" placeholder="Ocupación"/>
                        </Col>
                        <Col md={4} className="custom-mt-10">
                            <div className="text-muted">Lugar de Trabajo *</div>
                            <input type="text" value={trabajo} onChange={this.cambiaState("trabajo")} onBlur={this.cambiaValor("trabajo", "El campo Lugar de Trabajo es obligatorio")} className="form-control" placeholder="Trabajo"/>
                        </Col>
                        <Col md={8} className="custom-mt-10">
                            <div className="text-muted">Dirección de Trabajo *</div>
                            <input type="text" value={direccionT} onChange={this.cambiaState("direccionT")} onBlur={this.cambiaValor("direccionT", "El campo Dirección de Trabajo es obligatorio")} className="form-control" placeholder="Dirección de Trabajo"/>
                        </Col>
                        <Col md={4} className="custom-mt-10">
                            <div className="text-muted">Cargo *</div>
                            <input type="text" value={cargo} onChange={this.cambiaState("cargo")} onBlur={this.cambiaValor("cargo", "El campo Cargo es obligatorio")} className="form-control" placeholder="Cargo"/>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        );
    }
}
 
export default BecaSocioEc;


// WEBPACK FOOTER //
// ./src/views/EstSolicitudes/BecaSocioEc.jsx